import ChatIcon from "@mui/icons-material/Chat";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Menu } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import MDBadge from "@/components/atoms/MDBadge";
import MDBox from "@/components/atoms/MDBox";
import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import { useNotification } from "@/contexts/notification-context";
import { SidebarMessages } from "@/messages/layout/sidebar";
import NotificationItem from "@/mui/Items/NotificationItem";

interface Props {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: SidebarMessages;
}

export function ViewMessagesPopover({ isOpen, anchorEl, onClose, messages }: Props) {
  const router = useNavigate();
  const { lang } = useLanguage();
  const { unReadConversationsCount, notificationCount } = useNotification();

  const handleCheckNewMessages = () => {
    router(ROUTE_URLS.chat(lang));
  };

  const handleNotificationCenter = () => {
    router(ROUTE_URLS.notifications(lang));
  };

  const { view_messages, notification_center } = messages;

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      sx={{ mt: 2, pl: 10 }}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <MDBox color="inherit" display={"flex"} flexDirection={"column"} px={1.5}>
        <MDBadge
          color="secondary"
          badgeContent={unReadConversationsCount}
          size="xs"
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <NotificationItem
            onClick={handleCheckNewMessages}
            icon={<ChatIcon />}
            title={view_messages}
          />
        </MDBadge>

        <MDBadge
          color="secondary"
          badgeContent={notificationCount}
          size="xs"
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <NotificationItem
            onClick={handleNotificationCenter}
            icon={<NotificationsIcon />}
            title={notification_center}
          />
        </MDBadge>
      </MDBox>
    </Menu>
  );
}
